import type { PropsWithChildren } from 'react';
import { useRef } from 'react';

import type { TrackEvent, EventVariant } from '#types/tracking';
import { TracktorProvider } from 'react-tracktor';

import { TrackingRegistry } from '../tracking/TrackingRegistry';
import { GoogleTagManager } from '../tracking/google-tag-manager/GoogleTagManagerCustom';

import { useEnvironment } from './EnvironmentContext';

type Props = PropsWithChildren;

export function TrackingProvider({ children }: Props) {
	const { keys } = useEnvironment();

	const registryRef = useRef<TrackingRegistry | null>(null);
	// eslint-disable-next-line react-hooks/refs
	if (!registryRef.current) {
		registryRef.current = new TrackingRegistry(keys.GOOGLE_TAG_MANAGER_ID);
		// eslint-disable-next-line react-hooks/refs
		registryRef.current.register('gtm');
	}

	function dispatcher(trackingData: TrackEvent<EventVariant>) {
		if (registryRef.current) {
			registryRef.current.onEvent(trackingData);
		}
	}

	return (
		<>
			<GoogleTagManager gtmOrigin="pa.br.de" gtmId={keys.GOOGLE_TAG_MANAGER_ID} />
			<TracktorProvider dispatcher={dispatcher}>{children}</TracktorProvider>
		</>
	);
}
